import { observable, action } from 'mobx';
import ApiCaller from '../utils/api-caller';

class importItemLanguageStore {

    // Properties

    // Items Import Properties

    @observable categoryId = 0;
    @observable categoryName = '';
    @observable categories = [];
    @observable importItemLanguageLoading = false;

    // Category Import Properties
    
    // Init

    @action initImportItemLanguage() {
        this.categoryId = 0;
        this.importItemLanguageLoading = true;

        return ApiCaller.Item.apiGetParents().then((parentResponses) => {
            if (parentResponses) {
                this.categories = parentResponses;
            } else {
                this.categories = [];
            }
            
            this.importItemLanguageLoading = false;
        })
    }

    // SET Properties

    @action setCategoryId(value) {
        this.categoryId = value;

        const category = this.categories.find(fi => fi.parentId === value);
        if (category) {
            this.categoryName = category.parentName;
        } else {
            this.categoryName = '';
        }
    }
}

export default new importItemLanguageStore();